import { render } from "./WeeklyDiszpList.vue?vue&type=template&id=4ed36455&scoped=true"
import script from "./WeeklyDiszpList.vue?vue&type=script&lang=js"
export * from "./WeeklyDiszpList.vue?vue&type=script&lang=js"

import "./WeeklyDiszpList.vue?vue&type=style&index=0&id=4ed36455&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed36455"]])

export default __exports__